import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _16_PLAGUE_DISEASE_CONTROL:Partial<EcosystemServiceModel> ={
  id:'plague-disease-control',
  pos:16,
  image: "/images/ecoservices/plague_disease_control.jpg",
  code: ["2.2.3.1", "2.2.3.2"],
  unit:'plague & disease control',
  assetType:'other',
  serviceType: 'regulating',
  valuationMethods:[
    {
      id: 'default',
      name:"Default",
      unit: "m3",
      element: "plague control",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
